/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Wiki_Draftscreatedon2Inputs */



/**

* @param {_Wiki_Draftscreatedon2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _wiki_draftscreatedon2 = /** @type {((inputs?: _Wiki_Draftscreatedon2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Wiki_Draftscreatedon2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Erstellt am")
});
export { _wiki_draftscreatedon2 as "_wiki_draftsCreatedOn" }